<template>
  <div class="items">
    <v-container class="my-5">
      <v-row>
        <v-col>
          <ItemsTable :propHeaders="itemsHeaders" :propItems="items" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ItemsTable from '@/components/ItemsTable'

export default {
  name: 'Items',

  components: {
    ItemsTable
  },

  created () {
    // this.$store.dispatch('setItems', [])
    this.$store.dispatch('getItemsByFilter')
  },

  computed: {
    locations () {
      return this.$store.state.locations
    },

    items () {
      const items = this.$store.state.items
      items.map(item => {
        item.LocationName = this.locations.find(location => location.id === item.LocationId).name
      })
      return items
    }
  },

  data: () => ({
    itemsHeaders: [
      { text: 'Serial Number', value: 'serialNumber' },
      { text: 'Casing ID', value: 'casingId' },
      { text: 'IMSI', value: 'imsi' },
      { text: 'ICCID', value: 'iccid' },
      { text: 'Model', value: 'model' },
      { text: 'Location', value: 'LocationName' }
    ]
  })
}
</script>
